import moment from 'moment';

export default (str) => (
  moment(str).format('MMMM Do')
);



// WEBPACK FOOTER //
// ./src/formatters/date.js